export function getComputedStylePropertyValue(
  propertyName,
  root = typeof document !== "undefined" ? document.body : undefined,
) {
  if (!root || typeof window === "undefined") return ""

  return window.getComputedStyle(root).getPropertyValue(propertyName).trim()
}
